<template>
<div id="organizations">
    <vue-headful title="Organizations" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn class="ma-1" v-for="field in search_fields" :key="field.value" small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->
        <!--data table-->
        <v-card tile flat>
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-organization-item :item="item" :key="item.id" @click.native="seeItem(item)" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>
    <!-- add button -->
    <v-btn color="primary elevation-16" fab large fixed bottom right @click="dialog_add=true">
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <im-organization-add :item_id="item_id" :dialog="dialog_add" @exit="dialog_add=false,item_id=null" @refresh="getItems()"></im-organization-add>

    <im-organization-view :item_id="item_id" :dialog="dialog_view" @exit="dialog_view=false,item_id=null" @edit="edit($event)" @refresh="getItems()"></im-organization-view>

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../components/utils/PropDefaults.js";
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMSortField from "../../components/utils/IMSortField.vue";
import IMOrganizationItem from '../../components/items/Organizations/Card.vue';
import IMOrganizationView from '../../components/items/Organizations/ViewModal.vue';
import IMOrganizationAdd from '../../components/items/Organizations/AddModal.vue';

export default {
    components: {
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-organization-item': IMOrganizationItem,
        'im-organization-view': IMOrganizationView,
        'im-organization-add': IMOrganizationAdd,
    },

    data() {
        return {
            // modals
            dialog_mobile_sort: false,
            dialog_view: false,
            dialog_add: false,
            // item model
            item_id: null,
            organization: defaults.organization_item,

            // search
            search: null,
            search_fields: [
                {
                    text: 'ID',
                    value: 'id',
                    selected: true
                }, {
                    text: 'Name',
                    value: 'name',
                    selected: true
                },
            ],
            search_timeout: 500,

            //table
            loading: false,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],
            im_header: [{
                    text: "Name",
                    width: "25%",
                    sortable: false,
                    sort_order: 'name',
                    sort_dir: null,
                    align: 'center'
                }, {
                    text: "Type",
                    width: "8.3%",
                    sortable: false,
                }, {
                    text: "Contact",
                    width: "25%",
                    sortable: false,
                }, {
                    text: "Contact person",
                    width: "25%",
                    sortable: false,
                }, {
                    text: "Created at",
                    width: "16.7%",
                    sortable: false,
                },
            ],

            //props
            items: [],

        }
    },

    watch: {

        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200);
            }
        }

    },

    created() {
        this.getItems();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations';

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        seeItem(current_organization) {
            this.item_id = current_organization.id;
            this.dialog_view = true;
        },

        edit(value) {
            this.item_id = value;
            this.dialog_add = true;
            this.dialog_view = false;
        }

    }
}
</script>
<style>
.v-card .error-rules .v-text-field ::placeholder {
    color: red;
}
</style>
